import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const TutorDashboardSummaryReadSlice = createSlice({
  name: "TutorDashboardSummaryReadSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    TutorDashboardSummaryRead: (state) => {
      state.isLoading = true;
    },
    successTutorDashboardSummaryRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureTutorDashboardSummaryRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearTutorDashboardSummaryRead: (state) => {
      state.data = {};
    },
  },
});

export const {
  TutorDashboardSummaryRead,
  successTutorDashboardSummaryRead,
  failureTutorDashboardSummaryRead,
  clearTutorDashboardSummaryRead,
} = TutorDashboardSummaryReadSlice.actions;

export default TutorDashboardSummaryReadSlice.reducer;
